const releases = [
  {
    version: '1.6.3 - October 7th, 2026',
    link: 'https://confluence.nike.com/x/0Itmcg',
    overview: 'New device support, NPOS network update, and bug fixes',
    changes: [
      {
        title: `What's New in This Release`,
        list: [
          'Added support for traffic camera, payment terminal, and Palo Alto devices',
          'Updated network circuit scans on the NPOS feature to use the Palo Alto network',
          'Fixed a bug preventing port history from showing up correctly',
        ],
      },
    ],
  },
  {
    version: '1.6.2 - March 5th, 2026',
    link: 'https://confluence.nike.com/x/LkY7Xw',
    overview: 'Retail Hardware Status - Nike Only Feature',
    changes: [
      {
        title: `Retail Hardware Status - Nike Only Feature`,
        list: ['Only showing Nike stores in the Retail Hardware Status page'],
      },
    ],
  },
  {
    version: '1.6.1 - March 4th, 2026',
    link: 'https://confluence.nike.com/x/LkY7Xw',
    overview: 'Bug fixes and improvements',
    changes: [
      {
        title: `Bug fixes and improvements`,
        list: ['Fixed a bug where the search bar was not working correctly (A9-6969)'],
      },
    ],
  },
  {
    version: '1.6.0 - February 27th, 2026',
    link: 'https://confluence.nike.com/x/LkY7Xw',
    overview: 'Retail Hardware Status Feature added to Insights',
    changes: [
      {
        title: `Retail Hardware Status page added to the Insights menu`,
        list: [
          'Region View - View stats for each region by device type',
          'Store View - View stats for each store, you can see either network or ITAM inventory status',
          'Device View - View stats for each device by device type, with details on last seen date and ITAM inventory status description',
          'Ability to export region, store, and historical data to Excel files.',
        ],
      },
    ],
  },
  {
    version: '1.5.0 - June 2nd, 2025',
    link: 'https://confluence.nike.com/x/-TITQw',
    overview: 'Nike POS and Switch Connectivity Improvements',
    changes: [
      {
        title: `Nike POS (NPOS) is an advanced replacement for the legacy 1POS fixed point-of-sale system. NPOS leverages cloud services and a dedicated iOS app on iPads for registers and Customer-Facing Displays (CFDs). The Tech Insights tool provides visibility and real-time alerts to support troubleshooting of NPOS devices. As NPOS continues its global rollout, additional capabilities and insights will be introduced to enhance support and diagnostics.`,
        list: [
          'Diagram View - Quickly glance to see the NPOS Registers and their connected devices',
          'Table View - View devices by the device type',
        ],
      },
      {
        title: `The Nike POS feature aggregates data from multiple sources and presents it in a more digestible format. Alerts highlight potential issues that may prevent NPOS from functioning properly, such as missing or misconfigured devices.`,
        list: [],
      },
      {
        title: `Devices that are not configured as part of a workstation group are listed as Orphaned Devices under the Anomaly section.`,
        list: [],
      },
      {
        title: `Diagram View`,
        list: [
          'Quickly view NPOS registers and their connected devices, grouped by workstation assignments.',
          'Clicking a device icon opens a modal with device details and any associated alerts.',
        ],
      },
      {
        title: `Table View`,
        list: ['Use device-specific tabs to focus on a particular device category.'],
      },
      {
        title: `The Switch Connectivity feature now provides comprehensive status, data, and port configurations for switch devices across retail stores, showrooms, and distribution centers.`,
        list: [],
      },
      {
        title: `Enhanced Site Search`,
        list: [
          'The number of clicks required to filter search results has been significantly reduced.',
          'Transitioned from using IDFs as the primary method for searching distribution centers.',
        ],
      },
      {
        title: `Switch Stacks`,
        list: [
          'For sites, particularly Distribution Centers, that contain a large number of devices, a list of switch stacks will be provided if the site has more than one switch stack. Users can select the desired switch stacks using checkboxes.',
          'Each individual switch stack now features a unique VLAN legend.',
        ],
      },
      {
        title: `VLAN Legend Colors`,
        list: [
          'We aimed to make VLAN legend colors consistent. However, due to the large number of unique VLANs and the limited number of visually distinguishable colors, we prioritized reserving colors for the most frequently used VLANs in our database. This should help users quickly identify the most commonly used VLANs by color. The colors for other VLANs are selected somewhat randomly.',
        ],
      },
      {
        title: `Additional Features`,
        list: ['A refresh button has been added to enhance user experience.'],
      },
    ],
  },
  {
    version: '1.4.1 - June 6th, 2024',
    link: 'https://confluence.nike.com/x/TteDPQ',
    overview: 'Switch Port History',
    changes: [
      {
        title: `Switch Port History - We are pleased to release the early version of the port history feature. It's in its initial stages, but ready to provide value. Your feedback is crucial to help us improve it for a more stable release. Please share your thoughts to make this feature better for you on our slack channel #retailsupport-tools.`,
        list: [
          'History of devices that have previously been connected to a port has been added.',
          'Options have been added under the Switch Filter search bar. You can pick and choose between Current, Historical, or both when filtering for a specific device.',
        ],
      },
      {
        title: `Inventories - View and export devices in our database to csv.`,
        list: [
          'Select Custom tab if you want to view/export multiple geos at the same time, or you can select a Geo tab to get started.',
        ],
      },
    ],
  },
  {
    version: '1.3 - April 2nd, 2024',
    link: 'https://confluence.nike.com/x/om7POg',
    overview: 'Switch Connectivity Fixes and Enhancements',
    changes: [
      {
        title:
          'Based on user feedback, we have made some changes to the Switch Connectivity feature. We have fixed some bugs and made some enhancements to the feature.',
        list: [
          'Improved Search - will better handle user input and narrow down the list as more information is inserted into the field',
          'Search now allows you to filter and sort all sites more effectively',
          'Reduced the number of alerts and messages',
          'VLAN legend can now be pinned to the top of the screen',
        ],
      },
    ],
  },
  {
    version: '1.2 - January 30th 2024',
    link: 'https://confluence.nike.com/x/5RmuNw',
    overview: 'New Feature - Switch Connectivity',
    changes: [
      {
        title:
          'The Switch Connectivity from Retail Advisor has been brought over into Insights with added support for Distribution Centers and Showrooms. Switch Connectivity allows you to quickly visualize switch stacks so you can see important information for troubleshooting.',
        list: ['Added support for Distribution Centers', 'Added support for Showrooms'],
      },
    ],
  },
  {
    version: '1.1 - October 27st 2023',
    link: 'https://confluence.nike.com/x/EGyuNw',
    overview: 'Primarily contains bug fixes to RRP dashboard',
    changes: [
      {
        title: 'RRP Dashboard',
        list: [
          'Fixed Mouse Hover Effect on the Status Summary Component',
          'Fixed spelling error in the Cellular Backup alert modal',
          'Fixed some false alerts that was not correctly matching up to the Hardware Standard',
        ],
      },
      {
        title: 'Usage Logs',
        list: [
          'Updated usage logs to send an update on each page view',
          'Changed the logs actions property to only send a single string instead of an array of strings',
        ],
      },
      {
        title: 'Contact Page',
        list: ['Updated links for Jira, Contact Email, and Slack channel'],
      },
    ],
  },
  {
    version: '1.0 - March 31st 2023',
    link: 'https://confluence.nike.com/pages/viewpage.action?spaceKey=GROS&title=Insights+v.1.3.3',
    overview: 'Reoccuring Retail Physical Dashboard',
    changes: [
      {
        title: 'New RRP Dashboard',
        list: [
          'Allows you view stores that are most important to you when you use the Custom View tab.',
          'Geo Tabs will display all stores within the selected Geo',
          'Toggling the Card View allows you to focus on a store at a time.',
          'Card View can be exported into a jpg',
          'Alerts Icons can be clicked on to view additional details on why there is an Alert',
        ],
      },
    ],
  },
];

export default releases;
